import React from "react";
import { BonusPobjednici } from '../../Layout/BonusPobjednici.jsx';

export class PrventsvoHrvatskeBody extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: ['Raspored', 'Nagrade', 'Bodovi', 'Rezultati'],
            selectedTab: null,
            tuniri: null,
            showTurnir: null,
            turnirPobjednici: null
        }

        this.gotoTab = this.gotoTab.bind(this);
        this.getBody = this.getBody.bind(this);
        this.showTurnirRezultati = this.showTurnirRezultati.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.fetchTurnirRezultatiData = this.fetchTurnirRezultatiData.bind(this);
        this.setData = this.setData.bind(this);
        this.setTurnirPobjediniciData = this.setTurnirPobjediniciData.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Prvenstvo hrvatske', 'poker', this.props.user);
    }

    showTurnirRezultati(turnir) {
        this.setState({
            showTurnir: turnir,
            turnirPobjednici: null
        });

        this.fetchTurnirRezultatiData(turnir);
    }

    componentDidMount() {
        this.gotoTab(this.state.tabs[0]);
        this.fetchData();
    }

    fetchData() {
        this.props.showLoadingFn(true);

        const promises = Promise.all([casino.repos.pokerPrvenstvoHrvatskeTurniriRepo.list()]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    fetchTurnirRezultatiData(turnir) {
        this.props.showLoadingFn(true);

        const promises = Promise.all([casino.repos.pokerPrvenstvoHrvatskePobjedniciRepo.list(turnir)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setTurnirPobjediniciData, function (reason) { });
    }

    componentWillUnmount() {
        if (this.dataPromises)
            this.dataPromises.cancel();
    }

    setData(data) {
        const [turniri] = data;

        this.setState({
            turniri: turniri
        });

        this.props.showLoadingFn(false);
    }

    setTurnirPobjediniciData(data) {
        const [pobjedinici] = data;

        this.setState({
            turnirPobjednici: pobjedinici
        });

        this.props.showLoadingFn(false);
    }

    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }

    getBody() {
        if (this.state.selectedTab == 'Raspored') {
            return (
                <div>
                    <div id="raspored" className="padding-sides-medium-2">
                        <h2 id="anchor_opph" className="v3">{this.state.selectedTab}</h2>
                        {/*Uz <b>Main Event</b> s garantiranih <b>{casino.utils.numberWithCurrencyFromated(40000,'EUR')}</b>, igrat će se još nekoliko vrijednih turnira, a <b>raspored</b> pronađite dolje 👇🏻*/}
                        {/*<br /><br />*/}
                    </div>
                    <div>
                        {!this.state.turniri && <div>Dohvaćanje turnira...</div>}
                        {this.state.turniri &&
                            <div>
                                <table className="table-1 v2 v3">
                                    <thead>
                                        <tr>
                                            <th className="text-left text text-6">Buy-in</th>
                                            <th className="text-left text text-6">Turnir</th>
                                            <th className="text-left text text-6">Vrijeme</th>
                                            <th className="text-center text text-6">Rezultati</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {this.state.turniri.map((turnir) => {
                                            const datum = new Date(turnir.datum);
                                            return <tr className={
                                                turnir.sifra == "SPOP 01" ? "horizontal-lines bold" : turnir.sifra == "SPOP 08" ? "horizontal-lines bold" : turnir.sifra == "SPOP 11" ? "horizontal-lines bold" : turnir.sifra == "SPOP 15" ? "horizontal-lines bold" : "horizontal-lines"} key={turnir.datum}>

                                                <td className="text-left text text-7 nowrap">{casino.utils.numberWithCurrencyFromated(turnir.buyIn, "EUR")}</td>
                                                <td className="text text-1">
                                                    <span>{turnir.naziv}</span>
                                                </td>
                                                <td>
                                                    <span className="text text-1">{casino.utils.dateToTimeString(datum)}</span><br />
                                                    <span className="text text-2">
                                                        {datum.getDate() + '.' + (datum.getMonth() + 1) + '.' + datum.getFullYear().toString().slice(2) + "."}
                                                    </span>
                                                </td>
                                                <td className="text text-1 text-large text-center">
                                                    <a className="as-link" onClick={(e) => { e.preventDefault(); this.showTurnirRezultati(turnir) }}>
                                                        <span className="icon ico-search color-gray"></span>
                                                    </a>
                                                </td>
                                            </tr>
                                        }
                                        )}

                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>
                    <div className={"modal-dialog-overlay" + (this.state.showTurnir != null ? ' active' : '')}>
                        <div className="modal-dialog--inner flex-column">

                            <div className="modal-dialog-header clearfix">
                                <div className="modal-dialog--name">
                                    <span className="naziv">{this.state.showTurnir?.naziv}</span>
                                </div>
                                <a className="active pull-right as-link link link-1" onClick={(e) => { e.preventDefault(); this.setState({ showTurnir: null }) }}>
                                    <span className="close-icon icon ico-close-thin"></span>
                                </a>
                            </div>

                            <div className="modal-dialog-container flex-1">
                                <div className="modal-dialog-container--inner flex-equal-size">
                                    <div>
                                        <div className="relative">

                                            <div>
                                                <table className="table-1 v2">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-left text text-6">Alias</th>
                                                            <th className="text-center text text-6">Broj bodova</th>
                                                            <th className="text-right text text-6">Dobitak</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {!this.state.turnirPobjednici && <tr className="horizontal-lines"><td colSpan="3" className="text text-1">Dohvaćanje pobjednika...</td></tr>}

                                                        {!this.state.turnirPobjednici?.length && <tr className="horizontal-lines"><td colSpan="3" className="text text-1">Trenutno nema rezultata...</td></tr>}

                                                        {this.state.turnirPobjednici?.map((igrac) => {
                                                            return <tr className="horizontal-lines" key={igrac.alias}>
                                                                <td className="text text-1">
                                                                    <span>{igrac.alias}</span>
                                                                </td>
                                                                <td className="text text-center text-1">
                                                                    <span>{igrac.bodova}</span>
                                                                </td>
                                                                <td className="text-right text text-7 nowrap">{casino.utils.switchEurToKn(igrac.dobitak) + ' ' + casino.utils.switchCurrencyKnToEur()}</td>
                                                            </tr>
                                                        })}

                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        if (this.state.selectedTab == 'Nagrade') {
            return (<div>
                <div className="padding-sides-medium-2">
                    <h2 className="v3">{this.state.selectedTab}</h2>
                    <div>
                        <p><b>Postani novi poker prvak Hrvatske i osvoji put u Bratislavu! ✈️</b></p>
                        <p>SuperPoker Proljetno Prvenstvo – 15 dana, 15 turnira, 60.000 € nagrada!</p>
                    </div>
                </div>
                <table className="table-1 v2">
                    <thead>
                        <tr>
                            <th className="text-left text text-6">Plasman</th>
                            <th className="text-left text text-6">Nagrada</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="horizontal-lines">
                            <td className="text text-1 nowrap">🏆 1. – 3. mjesto</td>
                            <td className="text text-1">
                                Live paket <strong>Bratislava</strong> u vrijednosti <strong>3000 €+</strong>
                            </td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 nowrap">🎁 4. – 5. mjesto</td>
                            <td className="text text-1">
                                <strong>836 €</strong> u obliku <strong>11 ulaznica za turnire</strong>
                            </td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 nowrap">🎁 6. – 10. mjesto</td>
                            <td className="text text-1">
                                <strong>352 €</strong> u obliku <strong>7 ulaznica za turnire</strong>
                            </td>
                        </tr>
                        {/*<tr className="horizontal-lines">*/}
                        {/*    <td className="text text-1 nowrap">👉 4.- 5. mjesto</td>*/}
                        {/*    <td className="text text-1">*/}
                        {/*        <b>*/}
                        {/*            1.000 €*/}
                        {/*        </b>*/}
                        {/*    </td>*/}
                        {/*</tr>*/}
                        {/*<tr className="horizontal-lines">*/}
                        {/*    <td className="text text-1 nowrap">👉 6. - 10. mjesto</td>*/}
                        {/*    <td className="text text-1">*/}
                        {/*        <b>*/}
                        {/*            500 €*/}
                        {/*        </b>*/}
                        {/*    </td>*/}
                        {/*</tr>*/}
                        {/*<tr className="horizontal-lines">*/}
                        {/*    <td className="text text-1 nowrap">👉 11. - 20. mjesto</td>*/}
                        {/*    <td className="text text-1">*/}
                        {/*        <b>*/}
                        {/*            99 € ulaznice*/}
                        {/*        </b>*/}
                        {/*    </td>*/}
                        {/*</tr>*/}
                    </tbody>
                </table>
            </div>)
        }

        if (this.state.selectedTab == 'Bodovi') {
            return <div className="padding-sides-medium-2">
                <h2 className="v3">{this.state.selectedTab}</h2>
                <div>

                    Bodovi se dodjeljuju po slijedećoj formuli:
                    <br /><br />
                    <div className="max-width-40">
                        <img src="content/images/poker/bonusi/formula_2025.png" />
                    </div>
                    <ul>
                        <li className="text text-2">b = Broj natjecatelja u turniru + broj re-rentrya</li>
                        <li className="text text-2">u = Trošak ulaznice (buy-in) za turnir</li>
                        <li className="text text-2">p = Pojedinačni plasman igrača na turniru</li>
                    </ul>
                    <br />
                    U slučaju izjednačenog broja bodova gledat će se ukupno osvojena svota novaca na SS PP turnirima.
                </div>
            </div>
        }

        if (this.state.selectedTab == 'Rezultati') {
            return (
                <React.Fragment>
                    <h2 className="v3 padding-sides-medium-2">{this.state.selectedTab}</h2>
                    <BonusPobjednici {...this.props} />
                </React.Fragment>
            )
        }
    }

    renderTabs(tab) {
        return (
            <button
                key={tab}
                onClick={() => this.gotoTab(tab)}
                className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}>
                <span>{tab}</span>
            </button>
        )
    }

    render() {
        return (
            <div>
                <div className="segment v2 margin-top-small padding-sides-medium-2">
                    {this.state.tabs?.map((tab) => this.renderTabs(tab))}
                </div>
                {this.getBody()}
            </div>
        )
    }
}